import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from './endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

// Define a service using a base URL and expected endpoints
export const serviceProviderApi = createApi({
  reducerPath: 'serviceProviderApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['serviceProvider'],
  endpoints: (builder) => ({
    createBooking: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.serviceProviderDetailController.createBooking}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    updatePayment: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.serviceProviderDetailController.updatePayment}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    getAllServiceProviderDetail: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.serviceProviderDetailController.getAllServiceProviderDetail}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    findServiceProviderDetailById: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.serviceProviderDetailController.findServiceProviderDetailById}${body.id}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    findServiceProviderDetailByUserId: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.serviceProviderDetailController.findServiceProviderDetailByUserId}${body.userId}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    saveServiceProviderDetail: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.serviceProviderDetailController.saveServiceProviderDetail}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    updateServiceProviderDetail: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.serviceProviderDetailController.updateServiceProviderDetail}`,
          method: 'PUT',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    deleteServiceProviderDetail: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.serviceProviderDetailController.deleteServiceProviderDetail}${body.id}`,
          method: 'DELETE',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    serviceProviderId: builder.mutation({
      query: (body) => {
        return {
          url: `/serviceProviderDetail/findByUserId/${body.id}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),

    uploadForm: builder.mutation({
      query: (body) => {
        return {
          url: `${spotFinder.serviceProviderDetailController.uploadForm}/${body.serviceProviderId}/${body.docType}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    sendStripeOnboardEmail: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.serviceProviderDetailController.sendStripeOnboardEmail}${body.serviceProviderId}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllServiceProviderDetailMutation,
  useFindServiceProviderDetailByIdMutation,
  useFindServiceProviderDetailByUserIdMutation,
  useSaveServiceProviderDetailMutation,
  useUpdateServiceProviderDetailMutation,
  useDeleteServiceProviderDetailMutation,
  useServiceProviderIdMutation,
  useUploadFormMutation,
  useSendStripeOnboardEmailMutation,
  useCreateBookingMutation,
  useUpdatePaymentMutation
} = serviceProviderApi;
